import apiClient from "./apiClient.js";
import api from "./axiosClient";

/**
 * Get community metadata
 * GET /api/community/{category}
 */
export async function getCommunity(category) {
    const response = await apiClient.get(`/community/${category}`);
    return response.data;
}

/**
 * Get highlighted/trending posts
 * GET /api/community/{category}/highlights
 */
export async function getCommunityHighlights(category) {
    const response = await apiClient.get(
        `/community/${category}/highlights`
    );

    return response.data;
}

/**
 * Get products for this community
 * (Calls 5Buddies through your gateway or proxy)
 */
export async function getCommunityProducts(category) {
    console.log("Fetching products for category:", category);
    const response = await api.get(
        `/product/community/${category}`
    );
    console.log("Products response:", response.data);

    return response.data;
}

/**
 * Join Community
 * (Optional if needed later)
 */
export async function joinCommunity(category) {
    const response = await apiClient.post(
        `/community/${category}/join`
    );

    return response.data;
}